export default __webpack_public_path__ + "static/plane-fb599f55b43d4928a38e037c6d106b7e.png";